export interface PasswordConstraints {
  name: string;
  formKey: string;
}

export class UtilRules {
  public static getPasswordConstraints(): PasswordConstraints[] {
    return [
      {
        name: 'brokerRegistration.upPwdValidation1',
        formKey: 'invalidMinMaxPassword',
      },
      {
        name: 'brokerRegistration.upPwdValidation2',
        formKey: 'invalidAtLeastOnePassword',
      },
      {
        name: 'brokerRegistration.upPwdValidation3',
        formKey: 'invalidAcceptSymbols',
      },
    ];
  }
}
